import { defaultWordOfCaution, defaultFilterWordsOfCautionSga } from "./state";

/**
 * Mutación que lista las palabras de advertencia de SGA.
 *
 * @param {*} state.wordsOfCautionSga - Estado de las palabras de advertencia de SGA.
 * @param wordsOfCautionSga - Palabras de advertencia de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setWordsOfCautionSga(state, wordsOfCautionSga) {
    state.wordsOfCautionSga = wordsOfCautionSga;
}

/**
 * Mutación que establece la acción a realizar (Crear o actualizar).
 *
 * @param {*} state.action - Estado de la acción.
 * @param action - Acción a realizar (create o edit).
 * @return {void}
 * @author Brandon Torres
 */
export function setActionWordOfCautionSga(state, action) {
    state.action = action;
}

/**
 * Mutación que establece la palabra de advertencia por defecto.
 *
 * @param {*} state.wordOfCaution - Estado de la palabra de advertencia.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultWordOfCautionSga(state) {
    state.wordOfCaution = defaultWordOfCaution();
}

/**
 * Mutación que establece el filtro de las palabra de advertencia de SGA por defecto.
 *
 * @param {*} state.filterWordsOfCautionSga - Estado del filtro las palabra de advertencia de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultFilterWordsOfCaution(state) {
    state.filterWordsOfCautionSga = defaultFilterWordsOfCautionSga();
}

/**
 * Mutación que establece la cantidad de palabra de advertencia por página.
 *
 * @param {*} state.filterWordsOfCautionSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterWordsOfCautionSga.page - Página actual.
 * @param per_page - Cambio de cantidad de registros por página.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangeSizePagination(state, per_page) {
    state.filterWordsOfCautionSga = {
        ...state.filterWordsOfCautionSga,
        page: 1,
        per_page: per_page,
    };
}

/**
 * Mutación que establece la página actual.
 *
 * @param {*} state.filterWordsOfCautionSga.page - Página actual.
 * @param page - Cambio de página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangePagePagination(state, page) {
    state.filterWordsOfCautionSga.page = page;
}

/**
 * Mutación que establece el paginador de registros de palabras de advertencia.
 *
 * @param {*} state.filterWordsOfCautionSga.page - Página actual.
 * @param {*} state.filterWordsOfCautionSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterWordsOfCautionSga.total - Total de registros.
 * @param paginate - Paginación de registros.
 * @return {void}
 * @author Brandon Torres
 */
export function setPaginateWordsOfCautionSga(state, paginate) {
    state.filterWordsOfCautionSga = {
        ...state.filterWordsOfCautionSga,
        page: paginate.current_page,
        per_page: paginate.per_page,
        total: paginate.total,
    };
}

/**
 * Mutación que establece la palabra de advertencia de SGA.
 *
 * @param {*} state.wordOfCaution - Estado de la palabra de advertencia.
 * @param wordOfCaution - Palabra de advertencia de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setWordOfCautionSga(state, wordOfCaution) {
    state.wordOfCaution = wordOfCaution;
}

/**
 * Mutación que establece las palabras de advertencia activas de SGA.
 *
 * @param {*} state.activeWordsOfCaution - Estado de las palabras de advertencia activas de SGA.
 * @param activeWordsOfCaution - Palabras de advertencia activas de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setActiveWordsOfCautionSga(state, activeWordsOfCaution) {
    state.activeWordsOfCaution = activeWordsOfCaution;
}
